module.exports = __webpack_public_path__ + "img/map.919681af.svg";